export default {"src":"/_next/static/media/noResult.a50aa693.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};